import { useTranslation } from '@sib/i18n';
import { Button, CornerPanel, Separator } from '@sib/ui';
import workInProgressPopupImage from '../../../../public/images/WIP.png';

export interface WorkInProgressPopupContentProps {
  open: boolean;
  onDismiss: () => void;
  isDismissing?: boolean;
}

export const WorkInProgressPopupContent = ({
  open,
  onDismiss,
  isDismissing = false,
}: WorkInProgressPopupContentProps) => {
  const { t } = useTranslation();

  return (
    <CornerPanel open={open} withBackdrop>
      <div className="flex flex-col gap-4">
        <img
          src={workInProgressPopupImage}
          alt={t('internalPortal.workInProgressPopup.title')}
          className="mx-auto w-full object-contain"
        />
        <Separator decorative orientation="horizontal" />

        <div className="flex flex-col gap-2">
          <h2 className="text-primary text-lg font-semibold">
            {t('internalPortal.workInProgressPopup.title')}
          </h2>
          <p className="text-muted-foreground text-xs leading-normal">
            {t('internalPortal.workInProgressPopup.description')}
          </p>
        </div>

        <Button
          variant="outline"
          className="w-full"
          onClick={onDismiss}
          loading={isDismissing}
        >
          {t('internalPortal.workInProgressPopup.dismiss')}
        </Button>
      </div>
    </CornerPanel>
  );
};
